// Centralized Supabase configuration (Lovable constraint: avoid VITE_* env usage)

export const SUPABASE_URL = 'https://bgtvlegolklbpvamnveq.supabase.co';
export const SUPABASE_FUNCTIONS_URL = `${SUPABASE_URL}/functions/v1`;

// Public (publishable) anon key used by the frontend to call Supabase services.
// Safe to keep in client code.
export const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJndHZsZWdvbGtsYnB2YW1udmVxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg4ODQwOTAsImV4cCI6MjA2NDQ2MDA5MH0.cJsJbez_VSaOqWcMzWmo1iZPyby2pegd-Y6zwa2Ls4U';
